export default {
  ma_print_boleto: 'Imprimir boleto',
  ma_proceed_boleto: 'Por favor, prossiga com o pagamento do Boleto',
  ma_copy_link: 'Copiar o link',
  ma_link_copied: 'Link copiado!',
  ma_share_email: 'Compartilhe por e-mail',
  ma_share_email_mobile: 'Compartilhe por e-mail',
  ma_share_whatsapp: 'Compartilhe no WhatsApp',
  ma_share_whatsapp_mobile: 'Compartilhe no WhatsApp',
  ma_not_found_title: 'Número do pedido não encontrado.',
  ma_not_found: 'O número do pedido pesquisado não existe.',
  ma_go_homepage: 'Acesse a página inicial',
  ma_item_canceled: 'Artigo cancelado',
  ma_order: 'Pedido',
  ma_sup_not_alpha_message: 'Certifique-se de usar apenas números',
  ma_notification_sent: 'Você receberá um e-mail quando este produto estiver disponível novamente.',
  ma_click_order_details: 'Clique nos detalhes do pedido para rastrear cada pacote.',
  ma_thank_you: 'Agradecemos!',
  ma_send: 'Enviar',
  ma_email_restock:
    'Insira seu e-mail Se deseja ser informado quando este produto voltará ao estoque.',
  ma_email_notification:
    'Você receberá uma notificação se o produto estiver disponível nos próximos 30 dias',
  ma_mandatory: 'Este campo es obligatorio',
  ma_phone: 'Telefone',
  ma_sup_title: 'Crie uma conta',
  ma_sup_signup: 'Cadastre-se ',
  ma_sup_login: 'Faça login ',
  ma_sup_create_account: 'Inscreva-se e junte-se a nós',
  ma_sup_exclusives:
    'Ao se cadastrar, aproveite ofertas exclusivas, acesso prioritário e serviços especiais!',
  ma_sup_firstName: 'Nome',
  ma_sup_lastName: 'Sobrenome',
  ma_sup_show: 'Mostrar',
  ma_sup_hide: 'Ocultar',
  ma_password_requirments: 'A senha deve ter de 6 a 12 caracteres',
  ma_sup_gender_select_message: 'Selecione seu gênero:',
  ma_sup_name_error: 'Forneça seu nome',
  ma_sup_surname_error: 'Forneça seu sobrenome',
  ma_sup_no_to_say_option: 'Prefiro não dizer',
  ma_sup_female: 'Feminino',
  ma_sup_male: 'Masculino',
  ma_sup_birthdate_filled: 'Aniversário DD/MM/AAAA',
  ma_sup_day: 'Dia',
  ma_sup_month: 'Mês',
  ma_sup_year: 'Ano',
  ma_sup_birthdate: 'Aniversário',
  ma_sup_special_gift: 'Enviaremos um presente especial no seu aniversário! ',
  ma_sup_phoneNumber: 'Telefone',
  ma_sup_updates:
    'Inscreva-se para receber atualizações e ofertas exclusivas. Se mudar de ideia, cancele a inscrição quando quiser. Política de Privacidade  ',
  ma_sup_customize:
    'Personalize sua experiência de compra com nossos serviços premium on-line e na loja.  ',
  ma_typ_start_shopping: 'Comece a comprar',
  ma_sup_mail_title: 'INSCRIÇÃO NO NEWSLETTER',
  ma_sup_marketing_subscribe_message:
    'Ao marcar a caixa, você concorda em receber e-mails sobre nossas últimas coleções e ofertas especiais. Se mudar de ideia, cancele a inscrição quando quiser. Ao continuar, você confirma que leu e entendeu nossa {placeholderLink}.',
  ma_lip_signingin: 'Acessando',
  ma_lip_remember_me: 'Lembrar meus dados',
  ma_lip_forgot_password: 'Esqueceu sua senha?',
  ma_lip_login: 'Faça login',
  ma_lip_newHere: 'Primeira vez aqui? Junte-se a nós!',
  ma_lip_priority_access:
    'Seja membro da Sunglass Hut e aproveite ofertas exclusivas, acesso prioritário e serviços especiais! ',
  ma_lip_create_account: 'Inscreva-se e junte-se a nós',
  ma_pr_forgot_password: 'Esqueceu sua senha?',
  ma_pr_enter_email: 'Insira o endereço de e-mail associado à sua conta.',
  ma_pr_reset_password: 'Redefinir senha',
  ma_pr_back_login: 'Voltar para o login',
  ma_pr_email_sent: 'Enviamos um e-mail para {0}',
  ma_pr_check_inbox:
    'Se já tem uma conta, vai receber um link de redefinição na sua caixa de entrada.',
  ma_pr_reset_your_password: 'Redefinir sua senha',
  ma_pr_enter_new_password: 'Insira sua nova senha.',
  ma_pr_success_reset: 'Sua senha foi redefinida com sucesso! Faça login na sua conta abaixo.',
  ma_pr_password_specs:
    'As senhas precisam ter entre 6 e 12 caracteres e diferenciar maiúsculas de minúsculas.  ',
  ma_pr_new_password: 'Nova senha',
  ma_pr_confirm_new_password: 'Confirme a nova senha',
  ma_rpedm_forgot_password: 'ESQUECEU SUA SENHA?',
  ma_rpedm_dont_sweat: 'Não se preocupe. Clique abaixo para definir uma nova senha. ',
  ma_rpedm_set_new_password: 'Definir uma nova senha',
  ma_rpedm_questions_or_comments: 'Dúvidas ou comentários?',
  ma_rpedm_additional_info:
    'Se precisar de mais informações ou ajuda, visite nosso site ou ligue para 1.800.786.4527.',
  ma_PDPEX_login_add_to_bag: 'Faça login e adicione à sacola',
  ma_rpedm_already_have_account_login: 'Já tem uma conta?',
  ma_menu_overview: 'Resumo',
  ma_menu_login: 'Faça login ',
  ma_menu_create_account: 'Crie uma conta',
  ma_menu_women: 'Para elas ',
  ma_menu_men: 'Para eles ',
  ma_menu_giftcards: 'Vales-presente',
  ma_menu_sunny_services: 'Os melhores serviços',
  ma_wishlist: 'Lista de desejos',
  ma_frame_subtitle: 'Encontre seus óculos de sol perfeitos',
  ma_menu_account: 'Conta',
  ma_menu_profile: 'Perfil',
  ma_menu_details: 'Perfil',
  ma_menu_orderHistory: 'Pedidos',
  ma_menu_returnHistory: 'Devoluções',
  ma_menu_get_an_appointment: 'Horários agendados na loja',
  ma_menu_support: 'Suporte',
  ma_menu_logout: 'Sair',
  ma_lo_new_here: 'Primeira vez aqui? Junte-se a nós! ',
  ma_lo_exclusive_offers:
    'Seja membro da Sunglass Hut e aproveite ofertas exclusivas,<br/> acesso prioritário e serviços especiais! ',
  ma_lo_free_easy_returns: 'DEVOLUÇÕES FÁCEIS E GRATUITAS',
  ma_lo_replacement_coverage: 'COBERTURA PARA REPOSIÇÃO',
  ma_lo_perfect_fit: 'AJUSTE PERFEITO',
  ma_mm_add_giftcard: 'Adicione um vale-presente à sua conta',
  ma_mm_add_existing_giftcard: 'Adicione um vale-presente à sua conta e verifique seu saldo. ',
  ma_mm_add_card: 'Adicionar vale-presente',
  ma_mm_buy_giftcard: 'Quer comprar um vale-presente?',
  ma_mm_shop_sgh_giftcards: 'Compre vales-presente físicos e eletrônicos da Sunglass Hut',
  ma_mm_redeemable: 'resgatáveis no site e na loja.',
  ma_mm_shop_giftcards: 'Comprar vales-presente físicos',
  ma_mm_shop_egiftcards: 'Comprar vales-presente eletrônicos',
  ma_ov_overview: 'Resumo ',
  ma_mno_profile_details: 'Detalhes do perfil ',
  ma_mno_orders: 'PEDIDOS',
  ma_mno_returns: 'Devoluções',
  ma_mno_giftcards: 'Vales-presente',
  ma_mno_wishlist: 'Lista de desejos',
  ma_mno_appointments: 'Horários agendados na loja',
  ma_mno_logout: 'Sair',
  ma_pb_created: 'Criado',
  ma_pb_canceled: 'Cancelado',
  ma_pb_in_progress: 'Em andamento',
  ma_pb_shipped: 'Enviado',
  ma_pb_delivered: 'Entregue',
  ma_pb_returned: 'Devolvido ',
  ma_pb_prescription: 'ESPERANDO PARA VALIDAR RECEITA',
  ma_pb_rejected: 'REJEITADO',
  ma_pb_completed: 'CONCLUÍDO',
  ma_menu_welcome: 'Que bom rever você, {0}!',
  ma_menu_user: 'Olá, {0}!',
  ma_menu_user_mobile: 'Olá {0}',
  ma_menu_menu: 'Menu',
  ma_menu_title: 'Minha conta',
  ma_order_status_url: 'https://www.sunglasshut.com/br/status',
  ma_menu_ccare_link: 'Entre em contato conosco',
  ma_menu_wishlist: 'Lista de desejos',
  ma_menu_search: 'Pesquisar',
  ma_menu_cart: 'Carrinho',
  ma_menu_user_icon: 'Ícone de usuário da minha conta',
  ma_menu_user_icon_logged: 'Ícone de minha conta de um usuário logado',
  ma_menu_services_link: 'Nossos serviços',
  ma_menu_terms_link: 'Termos e condições',
  ma_order_history: 'Histórico de pedidos',
  ma_track: 'Veja e acompanhe seus pedidos e faça devoluções.',
  ma_orders_search_by: 'Caso não consiga localizar um pedido, ',
  ma_orders_search_by_continues: ' para pesquisar com o ID do pedido e seu endereço de e-mail.',
  ma_click_here: 'clique aqui',
  ma_returns_search_by: 'Caso não consiga encontrar uma devolução, pesquise com o ',
  ma_returns_search_by_link: 'ID do pedido e seu endereço de e-mail.',
  ma_no_orders: 'Você ainda não fez nenhum pedido. ',
  ma_support: 'Suporte',
  ma_menu_ccare_link_url: '/br/sunglasses/fale-conosco',
  ma_menu_services_link_url: '/br/sunglasses/servicos-para-voce',
  ma_menu_terms_link_url: '/br/clausulas-e-condicoes',
  ma_menu_shipping_link_url: '/br/frete-entrega',
  ma_our_services: 'Nossos serviços',
  ma_terms: 'Termos e condições',
  ma_menu_shipping_link: 'Envio e entrega',
  ma_cancel_within: 'Você pode cancelar até uma hora após a compra.',
  ma_read_more: 'Leia mais',
  ma_multiple_shipments: 'Há várias remessas neste pedido',
  ma_delivery_date: 'Você encontra a data de entrega de cada item na página de detalhes do pedido.',
  ma_track_parcel:
    'Acompanhe cada pacote na página de detalhes do pedido. Há um botão para rastrear a remessa ao lado de cada item. ',
  ma_cancel_order: 'Cancelar pedido',
  ma_order_number: 'Número do pedido',
  ma_engraving: 'Gravação',
  ma_customized: 'Personalizado',
  ma_engraving_case: 'Gravação de estojo',
  ma_details_product_case: 'Estojo',
  ma_details_product_case_electronics: 'Carregador incluído',
  ma_temple_tips: 'Ponteiras',
  ma_font_01: 'Regular',
  ma_font_02: 'It\u00E1lico',
  ma_font_03: 'Negrito',
  ma_font_16: 'Caligrafia 1',
  ma_font_17: 'Caligrafia 2',
  ma_font_18: 'Caligrafia 3',
  ma_details_product_sn: 'Número de série',
  ma_order_total: 'Total do pedido ',
  ma_order_details: 'Detalhes do pedido',
  ma_order_in_progress: 'Pedido 0230954: Em andamento',
  ma_omniOrder_being_processed: 'Seu pedido está sendo processado. ',
  ma_order_being_processed: 'Seu pedido está sendo processado e preparado para envio. ',
  ma_free_shipping: 'Frete grátis,',
  ma_order_shipped: 'Pedido 0230954 - Enviado',
  ma_track_order: 'Rastrear pedido',
  ma_order_awaiting_prescription: 'Pedido 0230954: Aguardando receita ',
  ma_cannot_prepare: 'Não podemos preparar seu pedido sem a receita.',
  ma_upload_or_send: 'Faça o upload abaixo ou envie para ',
  ma_customer_care: 'customercare@sgh.com',
  ma_prescription_glasses:
    'Óculos de grau serão entregues dentro de <span>7 dias úteis</span> após o recebimento da receita',
  ma_uplad_prescription: 'Fazer upload da receita',
  ma_create_return: 'Criar devolução',
  ma_order_delivered: 'Pedido 0230954: Entregue',
  ma_order_been_delivered: 'Seu pedido foi entregue no seu endereço.',
  ma_resend_ecard: 'Reenviar o vale-presente eletrônico por e-mail',
  ma_add_card: 'Adicione um cartão ao seu perfil',
  ma_order_canceled: 'Pedido 0230954: Cancelado',
  ma_order_been_canceled: 'Seu pedido foi cancelado.',
  ma_order_return_created: 'Pedido 0230954: Devolução criada',
  ma_return_limit: 'Você pode devolver este item até 18 de outubro de 2020',
  ma_print_label: 'Imprimir etiqueta',
  ma_change: 'alterar',
  ma_accepted_formats: 'Formatos aceitos: jpg, pdf, png. Tamanho máximo: 10 MB',
  ma_prescription_uploaded: 'Receita carregada',
  ma_issue: 'Algum problema com seu pedido?',
  ma_order_info: 'Informações do pedido',
  ma_order_date: 'Data do pedido',
  ma_return_number: 'Número da devolução',
  ma_delivery_info: 'Informações da entrega',
  ma_delivery_address: 'Endereço de entrega ',
  ma_delivery_method: 'Método de entrega',
  ma_billing_address: 'Endereço de cobrança',
  ma_delivered_within: 'Entregue em até <span>7 dias úteis</span> após o recebimento da receita',
  ma_prescription: 'Grau',
  ma_frame: 'Armação',
  ma_lenses: 'Lentes',
  ma_price: 'Preço',
  ma_subtotal: 'Subtotal',
  ma_discount: 'Desconto',
  ma_shipping_and_handling: 'Envio e manuseio ',
  ma_tax: 'Tarifas e impostos',
  ma_verifying: 'Pedido 0230954 - Verificando seu grau',
  ma_we_will_process: 'Processaremos seu pedido assim que ele for verificado. ',
  ma_order_created: 'Pedido 0230954 - Criado',
  ma_cancel_limit: 'Você pode cancelar até uma hora após a compra. Leia mais',
  ma_product_information: 'Informações do produto',
  ma_order_progress: 'Pedido 0230954 - Em andamento',
  ma_order_been_shipped: 'Seu pedido foi enviado e pode ser rastreado abaixo.  ',
  ma_download_invoice: 'Baixar a fatura',
  ma_click_on_link:
    'Clique no link de rastreamento acima de cada produto para rastrear cada pacote. Uma única remessa pode incluir mais de um produto',
  ma_return_created: 'Devolução 093498: Criada',
  ma_return_history: 'Histórico de devoluções ',
  ma_review_or_track: 'Verifique ou acompanhe uma devolução.',
  ma_goto:
    'Para criar uma devolução, acesse Histórico de pedidos e selecione o(s) item(ns) que você quer devolver.',
  ma_no_returns: 'Não há nenhuma devolução em andamento.',
  ma_return_details: 'Detalhes da devolução ',
  ma_please_note: 'NÃO É POSSÍVEL REEMBOLSAR SUA TAXA DE ENVIO ORIGINAL',
  ma_shipment_charge: 'Taxa de envio: ',
  ma_return_info: 'Informações de devolução',
  ma_return_date: 'Data de devolução',
  ma_return_address: 'Endereço de devolução',
  ma_return_method: 'Método de devolução ',
  ma_additional_info: 'Informação adicional de devolução',
  ma_return: 'Devolução',
  ma_return_instructions_1:
    'Para realizar a devolução basta apresentar o Código de postagem em uma agência dos Correios. Você será notificado assim que recebermos o seu produto. Qualquer dúvida entre em contato com a Central de Relacionamento.',
  ma_receive_email:
    'Enviaremos um e-mail avisando assim que recebermos seu pacote. Se houver um problema com sua devolução, nossa equipe entrará em contato com você.',
  ma_replace: 'Substituição',
  ma_replace_once_verified:
    'Se você precisar de uma substituição, assim que a peça for recebida no nosso Centro de Distribuição, nós enviaremos o novo produto. Para maiores informações, entre em contato conosco:',
  ma_refund: 'Reembolso',
  ma_refund_note:
    'Atenção: Após a verificação da sua devolução, reembolsaremos o montante pago ao seu método de pagamento original.',
  ma_credit_card_method:
    '- Cartão de crédito: O estorno irá acontecer em até duas faturas subsequentes, dependendo da administradora do seu cartão​',
  ma_paypal_method: '- PayPal: Em até 4 dias úteis​',
  ma_boleto_method:
    '- Boleto: Envie os dados bancários (Banco/Agência/Conta Corrente) do titular responsável pelo pedido para falecomasunglass@br.luxottica.com​',
  ma_partial_method:
    '- Parcial/totalmente pago com vale-presente: normalmente dentro de 2 dias úteis. Seu reembolso será devolvido ao vale-presente utilizado para fazer o pagamento original ',
  ma_return_in_progres: 'Devolução 093498: Em andamento ',
  ma_return_completed: 'Devolução 093498: Concluída',
  ma_return_rejected: 'Devolução 093498: Recusada',
  ma_hnu_just_for_you: 'Só para você',
  ma_hnu_complete_details: 'Preencha os detalhes da sua conta',
  ma_hnu_complete_email_title: 'Verifique seu e-mail para desbloquear a experiência completa',
  ma_hnu_complete_email_subtitle:
    'Sua conta é limitada. Para obter acesso integral, verifique seu e-mail clicando em “Verificar e-mail”. Em caso de problemas, entre em contato através do número 4000-1657',
  ma_hnu_complete_email_cta: 'Verifique seu e-mail',
  ma_hnu_personalized_experience: 'para ter uma experiência de compra personalizada.',
  ma_hnu_complete_profile: 'Preencher o perfil ',
  ma_hnu_your_special_offers: 'SUAS OFERTAS ESPECIAIS',
  ma_hnu_use_code: 'Use o código para ter R$ 50 de desconto comprando acima de R$ 200',
  ma_hnu_start_shopping: 'Comece a comprar ',
  ma_hnu_shop_exclusive_products: 'Compre produtos exclusivos',
  ma_hnu_shop_now: 'Compre agora mesmo',
  ma_hnu_in_store_pickup: 'Retirada na loja',
  ma_hnu_order_online:
    'Encomende on-line e retire na loja em apenas 2 horas úteis gratuitamente! Adicione ao seu perfil a loja mais próxima para ter seus óculos com você em ainda menos tempo.',
  ma_hnu_select_preferred_store: 'Selecione a loja preferida',
  ma_hnu_your_wishlist: 'Sua lista de desejos',
  ma_hnu_see_all_products: 'Veja todos os produtos ',
  ma_wl_out_of_stock: 'Esgotado',
  ma_wl_find_a_store: 'encontrar na loja',
  ma_add_to_bag: 'Adicionar à sacola',
  ma_wnl_login_wishlist: 'Faça login',
  ma_hnu_wishlist_empty:
    'Sua lista de desejos está vazia! Navegue em nosso site e salve seus modelos favoritos.',
  ma_hnu_your_orders: 'Seu histórico de pedidos',
  ma_hnu_your_last_order: 'Seu último pedido',
  ma_hnu_your_last_return: 'Sua última devolução',
  ma_hnu_see_all: 'Ver tudo ',
  ma_hnu_your_returns: 'Seu histórico de devoluções',
  ma_hnu_no_returns_in_progress: 'Não há nenhuma devolução em andamento.',
  ma_your_preferred_stores: 'Suas lojas preferidas',
  ma_no_saved_stores: 'Você ainda não salvou nenhuma loja.',
  ma_view_directions: 'Como chegar',
  ma_opening_hours: 'Horário de funcionamento',
  ma_services: 'Serviços:',
  ma_default_store: 'Essa é sua loja padrão',
  ma_delete: 'Excluir',
  ma_harg_add_a_giftcard: 'Adicione um vale-presente',
  ma_harg_card_number: 'Número do cartão',
  ma_harg_pin_number: 'Número do PIN',
  ma_harg_add_card: 'Adicionar vale-presente',
  ma_harg_are_you: 'Quer mesmo remover esse vale-presente da sua conta?',
  ma_hnu_remove_card: 'Remover o cartão da conta',
  ma_hnu_keep_card: 'Manter',
  ma_hnu_your_giftcards: 'Seus vales-presente',
  ma_hnu_manage_giftcard: 'Gerencie vales-presente físicos e eletrônicos e verifique seu saldo',
  ma_hnu_add_giftcard: 'Adicione um vale-presente à sua conta',
  ma_hnu_add_existing_giftcard: 'Adicione um vale-presente à sua conta e verifique seu saldo. ',
  ma_hnu_add_card: 'Adicionar vale-presente',
  ma_hnu_looking_giftcard: 'Quer comprar um vale-presente?',
  ma_hnu_shop_gifts: 'Compre vales-presente físicos e eletrônicos da Sunglass Hut',
  ma_hnu_redeemable: 'resgatáveis no site e na loja.',
  ma_hnu_shop_giftcards: 'Comprar vales-presente físicos',
  ma_hnu_shop_egiftcards: 'Comprar vales-presente eletrônicos',
  ma_hnu_card_number: 'Número do cartão ',
  ma_hnu_pin_number: 'Número do PIN',
  ma_hnu_balance: 'Saldo',
  ma_hnu_your_purchases: 'Suas compras',
  ma_hnu_egiftcard: 'Vale-presente eletrônico',
  ma_hnu_resend_card: 'Reenviar o vale-presente por e-mail',
  ma_hnu_check_balance: 'Verifique as atualizações de saldo',
  ma_hnu_giftcard_no_purchases: 'Você não fez nenhuma compra com este vale-presente. ',
  ma_csg_delivery: 'Entrega',
  ma_csg_payment: 'Pagamento ',
  ma_csg_total_amount: 'Total',
  ma_csg_have_giftcard: 'Tem um vale-presente? ',
  ma_csg_add_giftcard: 'Adicionar um vale-presente',
  ma_csg_card_number: 'Número do cartão',
  ma_csg_pin_number: 'Número do PIN',
  ma_csg_whats_this: 'O que é isso? ',
  ma_csg_card_details: 'Detalhes do cartão ',
  ma_csg_name_on_card: 'Nome no cartão ',
  ma_csg_expiration_date: 'Data de vencimento ',
  ma_csg_cvv: 'CVV',
  ma_csg_pay_and_confirm: 'Pagar e confirmar o pedido ',
  ma_csg_order_summary: 'Resumo do pedido',
  ma_csg_shipping_cost: 'Custo de envio',
  ma_csg_tax: 'Tarifas e impostos',
  ma_csg_delivery_details: 'Detalhes da entrega',
  ma_csg_estimated_date: 'Previsão de entrega:',
  ma_csg_estimated_date_custom: 'Previsão de entrega para produtos personalizados',
  ma_csg_deliver_to: 'Entregar para:',
  ma_csg_items_in_cart: 'Itens no seu carrinho',
  ma_csg_card_not_found:
    'Não encontramos o número do seu cartão. Onde encontro o número do meu cartão?',
  ma_csg_incorrect_pin: 'Seu número PIN está incorreto. Onde encontro meu número PIN?',
  ma_csg_giftcard_number_location:
    'O número do seu vale-presente de 16 dígitos fica no verso do cartão, na parte inferior.',
  ma_csg_card_pin_location: 'Seu número PIN de 8 dígitos fica no verso do vale-presente. ',
  ma_wnl_your_isempty: 'Sua lista de desejos está vazia!',
  ma_wnl_browse: 'Navegue em nosso site e salve seus modelos favoritos',
  ma_wnl_start_shopping: 'Comece a comprar',
  ma_wnl_login_see_items: 'Faça login para ver seus itens salvos',
  ma_shared_wishlist: 'Lista de desejos compartilhada',
  ma_sharer: 'Lista de desejos de {0}',
  ma_your_wishlist: 'Sua lista de desejos',
  ma_wnl_signup_or_login:
    'Crie uma conta ou faça login para gerenciar sua lista de desejos e salvar novos itens',
  ma_share_wishlist: 'Compartilhe sua lista de desejos!',
  ma_wl_email_me: 'Avise-me quando estiver disponível',
  ma_signin_add_bag: 'Faça login e adicione à sacola',
  ma_wnl_login_add_bag: 'Faça login e adicione à sacola',
  ma_page_unavailble: 'Esta página não está mais disponível',
  ma_wl_link_expired:
    'O link expirou ou essa lista não está mais disponível. Navegue em nosso site para salvar modelos na sua lista de desejos.',
  ma_wml_check_my_wishlist: 'Confira minha lista de desejos da Sunglass Hut!',
  ma_wml_shop_favorite: 'Comprar meus modelos favoritos em:',
  ma_breadcrumb_details: 'DETALHES DO PERFIL',
  ma_breadcrumb_orderHistory: 'Histórico de pedidos',
  ma_breadcrumb_returnHistory: 'Histórico de devoluções',
  ma_pdi_your_profile: 'Seu perfil ',
  ma_pdi_manage_account:
    'Gerenciar informações relacionadas à sua conta, detalhes pessoais e endereços de lojas preferidas',
  ma_pd_pInfo: 'Informações pessoais',
  ma_pdi_complete_your_info: 'Preencha suas informações pessoais',
  ma_pd_edit: 'Editar',
  ma_sup_email: 'Endereço de e-mail',
  ma_pdi_first_name: 'Nome',
  ma_pdi_last_name: 'Sobrenome',
  ma_pdi_gender: 'Gênero',
  ma_pdi_birthdate: 'Data de nascimento',
  ma_pdi_phone: 'Telefone',
  ma_pdi_complete_your_profile: 'Preencha seu perfil',
  ma_pd_lInfo: 'Informações de login',
  ma_pdi_change_email: 'Alterar e-mail ',
  ma_sup_password: 'Senha',
  ma_pd_edit_password: 'Editar senha',
  ma_pd_edit_address: 'Editar Endereço',
  ma_pd_addressBook: 'Endereços cadastrados',
  ma_pd_addAddress: 'Adicione um endereço',
  ma_pdi_no_addresses: 'Você ainda não salvou nenhum endereço.',
  ma_pdi_add_automatic_address:
    'Adicione um endereço e salve-o como padrão para preencher automaticamente suas informações de envio na finalização da compra. ',
  ma_pdi_save_automatic_address:
    'Salve seu endereço padrão e suas informações de entrega serão preenchidas automaticamente ao finalizar sua compra.',
  ma_pdi_prefered_stores: 'Suas lojas preferidas',
  ma_add_store: 'Adicionar loja',
  ma_add_store_favourites: 'Adicionar loja aos favoritos',
  ma_closed_store_favourites: 'Fechado',
  ma_pdi_no_stores_saved: 'Você ainda não salvou nenhuma loja.',
  ma_pdi_contanct_preferences: 'Preferências de comunicação',
  contact_phone_title: 'Celular',
  ma_sup_email_consent:
    'Ao marcar a caixa, você concorda em receber e-mails sobre nossas últimas coleções e ofertas especiais. Se mudar de ideia, cancele a inscrição quando quiser. Ao continuar, você confirma que leu e entendeu nossa Política de Privacidade.',
  ma_pdi_add_new_address: 'Adicionar um novo endereço',
  ma_pdi_set_default_delivery: 'Definir como endereço de entrega padrão',
  ma_pdi_your_default_billing_address: 'Este é seu endereço de cobrança padrão',
  ma_pdi_your_default_delivery_address: 'Este é seu endereço de entrega padrão',
  ma_pdi_default_store: 'Essa é sua loja padrão',
  ma_pdi_set_default_billing: 'Definir como endereço de cobrança padrão',
  ma_pdi_pickup_or_book: 'Serviços:     Retirar na loja | Agendar um horário',
  ma_pdi_update_personal_info: 'Atualize suas informações pessoais',
  ma_pdi_save_profile: 'Salvar perfil',
  ma_epo_update_password: 'Atualize sua senha',
  ma_epo_current_password: 'Senha atual',
  ma_epo_new_password: 'Nova senha',
  ma_epo_confirm_password: 'Confirme a nova senha',
  ma_epo_save_password: 'Salvar senha',
  ma_eeo_change_address: 'Alterar endereço de e-mail',
  ma_eeo_new_address: 'Novo endereço de e-mail',
  ma_eeo_save_email: 'Salvar e-mail ',
  ma_aao_update_address: 'Atualize seu endereço',
  ma_aao_phoneNumber: 'Telefone',
  ma_aao_privacy_usage: 'Utilizaremos o telefone somente se ocorrerem problemas com o seu pedido.',
  ma_aao_street_address: 'Endereço ',
  ma_aao_please_check_address: 'Confira se o endereço está correto e contém o número do imóvel',
  ma_aao_apartment_floor: 'Casa, apartamento, bloco, andar (opcional)',
  ma_aao_zipcode: 'CEP',
  ma_aao_check_zipcode: 'Esqueceu seu CEP? {placeholderLink}',
  ma_busca_cep_link: 'https://buscacepinter.correios.com.br/app/endereco/index.php',
  ma_busca_cep_placeholder: 'Calcule-o',
  ma_aao_city_or_code: 'Cidade',
  ma_aao_country: 'País/Região',
  ma_aao_unsaved_details: 'Detalhes não salvos',
  ma_aao_save_exit: 'Salvar e sair',
  ma_aao_leave_saving: 'Sair sem salvar',
  ma_enter_location: 'Insira a localização',
  ma_enter_your_location: ' Insira sua localização',
  ma_view_all_stores: 'Ver todas as lojas Sunglass Hut',
  ma_aao_save_address: 'Salvar endereço',
  ma_aao_delete_address: 'Excluir endereço',
  ma_aao_delete_address_confirm: 'Quer mesmo excluir este endereço?',
  ma_aao_yes_delete_address: 'Sim, excluir o endereço',
  ma_aao_no_keep_address: 'Não, manter o endereço',
  ma_set_default_store: 'Definir como sua loja padrão ',
  ma_delete_store: 'Excluir loja favorita',
  ma_delete_store_confirm: 'Quer mesmo excluir esta loja?',
  ma_yes_delete_store: 'Sim, excluir a loja',
  ma_keep_store: 'Não, manter a loja',
  ma_ss_pickup_in_store: 'RETIRADA NA LOJA - GRÁTIS',
  ma_ss_collect_in_store: 'Compre on-line e retire na loja. Disponível 2 horas após a compra.',
  ma_ss_select_preferred_store: 'Selecione sua loja preferida',
  ma_fs_find_in_store: 'Encontre na loja ',
  ma_fs_your_item: 'Seu item ',
  ma_fs_your_store: 'Sua loja Sunglass Hut:',
  ma_fs_book_appointment_discover: 'Agende um horário para descobrir a experiência Stella ',
  ma_fs_call_to_reserve: 'Ligue para reservar por 24h',
  ma_fs_favorite_store: 'Loja favorita',
  ma_fs_removed_from_stores: 'Removida das lojas preferidas',
  ma_fs_added_to_stores: 'Adicionada às lojas preferidas',
  ma_fs_change_location: 'Alterar localização',
  ma_fs_find_store: 'Encontre uma loja Sunglass Hut ',
  ma_fs_enter_location: 'Insira um local (CEP, endereço ou cidade) ',
  ma_fs_safe_stores_description:
    'Recentemente, abrimos lojas em regiões consideradas seguras para a realização de negócios. Nessas lojas recém-inauguradas, estamos tomando medidas adicionais de precaução para garantir o melhor para nossos clientes e funcionários. A retirada na loja estará disponível em alguns locais. Verifique a disponibilidade do serviço na sua região ao finalizar a compra. Continuamos abertos 24 horas em www.sunglasshut.com. Cuide-se e prepare-se para dias mais tranquilos pela frente.',
  ma_fs_sgh_stores: 'Lojas Sunglass Hut ',
  ma_fs_preferred_store: 'Loja preferida',
  ma_fs_appointment_in_store: 'Horário agendado na loja',
  ma_in_store_appointments: 'Horários agendados na loja',
  ma_book_with_consultants:
    'Agende um horário na loja com nossos consultores de estilo e tenha uma experiência de compra personalizada com base nas suas necessidades.',
  ma_book_an_appointment: 'Agendar um horário',
  ma_no_appointments: 'Você não agendou nenhum horário. ',
  ma_fs_upcoming_appointments: 'Próximos agendamentos',
  ma_select_calendar: 'Selecione sua agenda',
  ma_apple_calendar: 'Agenda da Apple',
  ma_google_calendar: 'Agenda do Google',
  ma_add_calendar: 'Adicionar à agenda',
  ma_fs_reschedule: 'Reagendar',
  ma_fs_cancel: 'Cancelar',
  ma_fs_visit_purpose: 'PROPÓSITO DA VISITA',
  ma_fs_location: 'LOCALIZAÇÃO',
  ma_fs_view_contact_info: 'Suas informações de contato',
  ma_fs_past_appointments: 'Agendamentos anteriores',
  ma_fs_cancel_appointment: 'Cancelar o agendamento',
  ma_fs_cancel_confirmation: 'Quer mesmo cancelar?',
  ma_fs_keep_appointment: 'Manter o agendamento',
  ma_appointment_booking: 'Agendamento de horário',
  ma_book_preferred_store: 'Quer agendar um horário na loja de sua preferência?',
  ma_book_this_store: 'Agendar nesta loja',
  ma_choose_another_store: 'Escolher outra loja',
  ma_select_a_store: '1. SELECIONE UMA LOJA',
  ma_choose_appointment_type: '2. ESCOLHA UM TIPO DE AGENDAMENTO',
  ma_choose_date_and_time: '3. ESCOLHA UMA DATA E HORA',
  ma_sup_mandatory: 'Esse campo é obrigatório',
  ma_save_on_calendar: '4. ADICIONE À SUA AGENDA',
  ma_fs_first_name: 'Forneça seu nome.',
  ma_fs_last_name: 'Forneça seu sobrenome.',
  ma_fs_enter_valid_date: 'Insira uma data válida no formato: MM/DD/AAAA',
  ma_fs_email_format: 'Insira seu endereço de e-mail no formato: seunome@exemplo.com',
  ma_lip_invalid_password_message:
    'Sua senha precisa ter entre 6 e 12 caracteres e diferenciar maiúsculas de minúsculas.',
  ma_lip_show_password: 'Mostrar',
  ma_lip_hide_password: 'Ocultar',
  ma_fs_already_signup: 'Parece que você já tem uma conta. Faça login',
  ma_fs_enter_new_password: 'Insira a nova senha ',
  ma_fs_verify_password: 'Verifique e insira a senha novamente ',
  ma_fs_enter_password_again: 'Insira a senha novamente.',
  ma_fs_credentials_problem:
    'Há algum problema com o endereço de e-mail e/ou senha que você digitou. Tente novamente.',
  ma_fs_email_not_mach:
    'Este e-mail não corresponde a nenhuma conta cadastrada. Crie uma conta aqui',
  ma_fs_password_incorrect: 'Essa senha está incorreta. Tente novamente. ',
  ma_fs_login_impossible: 'Não foi possível fazer login na sua conta.',
  ma_fs_try_again: 'Tente novamente. ',
  ma_fs_email_not_in_database: 'Este e-mail não está no nosso banco de dados. Crie uma conta aqui',
  ma_fs_password_reset_success: 'Sua senha foi redefinida com sucesso!',
  ma_fs_login_below: 'Faça login na sua conta abaixo.',
  ma_sup_new_account: 'Inscreva-se e junte-se a nós',
  ma_billingCode: 'CPF ou CNPJ',
  ma_fax2: 'Nùmero',
  ma_municipio: 'Incluir complemento se disponível',
  ma_colonia: 'Bairro',
  ma_email: 'Endereço de e-mail',
  ma_password: 'Senha ',
  ma_firstName: 'Nome ',
  ma_lastName: 'Sobrenome ',
  ma_gender_select_message: 'Selecione seu gênero:',
  ma_phoneNumber: 'Número de telefone',
  ma_newEmail: 'Novo endereço de e-mail',
  ma_currentPassword: 'Senha atual',
  ma_newPassword: 'Nova senha',
  ma_confirmPassword: 'Confirme a nova senha',
  ma_streetAddress: 'Endereço ',
  ma_addressApartment: 'Casa, apartamento, bloco, andar (opcional)',
  ma_zipCode: 'CEP',
  ma_city: 'Cidade',
  ma_state: 'Estado',
  ma_country: 'País',
  ma_default_delivery_address: 'Definir como endereço de entrega padrão',
  ma_default_billing_address: 'Definir como endereço de cobrança padrão',
  ma_mobilePhone1Country: 'Inscrição Estadual',
  ma_invalid_mobilePhone1Country: 'Por favor, informe a Inscrição Estadual',
  ma_phone2Type: 'ISENTO',
  ma_no_to_say_option: 'Prefiro não dizer',
  ma_female: 'Feminino',
  ma_choose_password: 'Escolha uma senha difícil de adivinhar, mas fácil de lembrar.',
  ma_password_must_include: 'Sua senha deve incluir pelo menos:',
  ma_val_minimumPasswordLength: '{0} caractere',
  ma_val_minimumPasswordLength_plural: '{0} caracteres',
  ma_val_minUppercase: '{0} letra maiúscula (A-Z)',
  ma_val_minUppercase_plural: '{0} letra maiúscula (A-Z)',
  ma_val_minLowercase: '{0} letra minúscula (a-z)',
  ma_val_minLowercase_plural: '{0} letra minúscula (a-z)',
  ma_val_minimumNumeric: '{0} número (0-9)',
  ma_val_minimumNumeric_plural: '{0} número (0-9)',
  ma_val_minimumSpecialCharacter: '{0} caractere especial (!£#)',
  ma_val_minimumSpecialCharacter_plural: '{0} caractere especial (!£#)',
  ma_verify_password: 'Verificar senha',
  ma_pwd_error_generic: 'A senha não cumpre todos os requisitos',
  ma_pwd_error_old: 'Sua nova senha deve ser diferente da anterior',
  ma_pwd_error_matchUserId: 'Sua senha não pode ser igual ao nome de usuário',
  ma_pwd_error_maximumConsecutiveType:
    'A senha não pode conter mais de {0} caracteres iguais seguidos',
  ma_pwd_error_maximumInstances: 'A senha não pode conter mais de {0} caracteres iguais',
  ma_pwd_expired: 'Sua senha expirou. Atualize sua senha antes de fazer login.',
  ma_male: 'Masculino',
  ma_invalid_email_message: 'Por favor, informe um e-mail válido',
  ma_address_error: 'Por favor, informe um endereço válido',
  ma_length: 'Insira no máximo {0} caracteres',
  ma_city_error: 'Insira uma cidade válida',
  ma_state_error: 'Insira um estado válido',
  ma_country_error: 'Insira um país válido',
  ma_name_error: 'Forneça seu nome.',
  ma_surname_error: 'Forneça seu sobrenome.',
  ma_not_alpha_message: 'Certifique-se de usar apenas números',
  ma_password_message: 'A senha deve ter de 6 a 12 caracteres',
  ma_invalid_password_message:
    'Sua senha precisa ter entre 6 e 12 caracteres e diferenciar maiúsculas de minúsculas.',
  ma_invalid_password_match_message: 'As senhas não correspondem',
  ma_not_zip_message: 'Por favor verifique o número do CEP de acordo com o padrão xxxxx-xxx',
  ma_invalid_billingCode_message: 'Por favor, informe um CPF ou CNPJ válido',
  ma_invalid_billingCode_message_cpf: 'Por favor, informe um CPF válido',
  ma_not_phone_message: 'Por favor, informe um número de telefone válido',
  ma_number_error: 'Por favor, informe um número',
  ma_municipio_error: 'A capacidade máxima desse campo é de 10 caracteres',
  ma_colonia_error: 'Por favor, informe o bairro',
  ma_fax2_error: 'Por favor, informe um número',
  ma_min_age_message: 'Você precisa ter pelo menos 16 anos para se cadastrar {placeholderLink}',
  ma_min_age_link: 'https://www.sunglasshut.com',
  ma_item_deleted_wishlist: 'O item foi removido da sua lista de desejos.',
  ma_undo: 'Desfazer',
  ma_expired_link: 'O link para redefinir sua senha expirou',
  ma_request_link: 'Solicite um novo link.',
  ma_new_link: 'Enviar um novo link ',
  ma_unavailable_products: 'Produtos indisponíveis',
  ma_perfect_shades: 'Encontre seus óculos de sol perfeitos',
  ma_perfect_shades_message:
    'Encontre seus óculos de sol perfeitos deixe que nossa tecnologia de sugestão de armações',
  ma_frame_advisor_messagge:
    'Deixe que nossa tecnologia de sugestão de armações encontre o melhor modelo para o formato de seu rosto e suas preferências!',
  ma_get_started: 'Vamos começar!',
  ma_prescription_file_size_error: 'O tamanho do arquivo é muito grande.',
  ma_read_more_description:
    'Si se desea cambiar o cancelar un pedido realizado recientemente, se nos puede contactar lo antes posible llamando al <b>800.000.808</b>, de lunes a viernes, de 10 a.m. a 19 p.m., y haremos todo lo posible para cumplir con la solicitud. <b>Sin embargo, se deberá tener en cuenta que, debido a que nuestro sistema está diseñado para procesar los pedidos con rapidez</b>, no podremos garantizar la posibilidad de cancelar o cambiar el pedido una vez se haya iniciado el proceso de envío.',
  how_return_product: 'Como devolver o produto',
  how_return_product_embale_description:
    'Embale o(s) produto(s) na embalagem original, incluindo eventuais documentos, acessórios e manuais recebidos com o produto - certifique-se de que a embalagem esteja bem fechada e que o conteúdo não corra o risco de sofrer danos durante o transporte.',
  how_return_product_dirijase_description:
    'Dirija-se a uma agência dos Correios com o Código de postagem para enviar seu produto à Sunglass Hut.',
  ma_returnflow_email: 'E-mail',
  ma_returnflow_phone: 'Telefone',
  ma_img_map: 'Brazil',
  ma_find_store: 'Encontre uma loja',
  ma_find_store_address: 'Entrega:',
  ma_find_store_view: 'Ver todas as lojas Sunglass Hut',
  ma_call_and_reserve_link:
    'https://www.sunglasshut.com/us/sunglasses/services-for-you?callreserve',
  ma_call_and_reserve: 'Ligue para reservar por 24h',
  ma_call_and_reserve_aria_label: 'Ligue para reservá-lo por 24h abre em uma nova janela',
  ma_pick_up_in_store: 'Agendar um horário',
  ma_sl_link_with_book_appointment: '/br/sunglasses/localizador-de-lojas?bookingAvailable=true',
  ma_sup_privacy_policy_url: '/br/sunglasses/politica-de-privacidade',
  ma_expired_password: 'Sua senha expirou.',
  ma_update_password: 'Atualize sua senha aqui',
  email_verification_cofirmation: 'Seu e-mail foi confirmado com sucesso',
  email_verification_cofirmation_body:
    'Sua conta foi ativada. Clique em {placeholderLink} para navegar no site.',
  email_verification_cofirmation_button: 'Começar a comprar',
  email_verification_expired: 'Ops, o link não está mais ativo.',
  email_verification_expired_body: 'Gerar um novo ao clicar no botão abaixo.',
  resend_email: 'Reenviar e-mail',
  ma_check_inbox: 'Verifique sua caixa de entrada',
  ma_check_inbox_body:
    'Enviamos um e-mail para você. Verifique sua caixa de entrada e confirme sua conta. Se não tiver recebido nada, clique em "{placeholderLinkResendEmail}".',
  date_error: 'Para prosseguir,você ser maior de idade',
  ma_dialog_alert_0: 'Delete address dialog',
  ma_dialog_alert_1: 'Caixa de diálogo para preenchimento de perfil',
  ma_dialog_alert_2: 'Caixa de diálogo para encontrar uma loja',
  ma_dialog_alert_3: 'Caixa de diálogo para exclusão da loja favorita',
  ma_dialog_alert_4: 'Caixa de diálogo para atualizar suas informações pessoais',
  ma_dialog_alert_5: 'Caixa de diálogo para alteração do endereço de e-mail',
  ma_dialog_alert_6: 'Caixa de diálogo para atualizar sua senha',
  ma_dialog_alert_7: 'Caixa de diálogo para começar',
  ma_dialog_alert_8: 'Adicione um endereço',
}
